export default __webpack_public_path__ + "static/media/trio.a013c776.dae";